import React, { useState, useEffect } from "react";
import moment from "moment";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Brush, Tooltip, Legend, ResponsiveContainer } from "recharts";

function useChartData(chartData, transformedList) {
  const [datedData, setDatedData] = useState([]);

  useEffect(() => {
    // console.log("===> useChartData 실행됨 ==> ");
    if (chartData && Array.isArray(chartData) && Array.isArray(transformedList)) {
      const prevValues = {};

      const formattedData = chartData.map((item, index) => {
        const newItem = { ...item };
        Object.keys(newItem).forEach(key => {
          if (typeof newItem[key] === 'string') {
            newItem[key] = newItem[key].trim(); // 공백 제거
          }
        });

        const formattedDate = moment(newItem.YMD).format('YYYY-MM-DD HH:mm');
        const transformedItem = {
          YMD: formattedDate,
          name: newItem.YMD
        };

        transformedList.forEach(({ chnnlNm }) => {
          const prevValue = prevValues[chnnlNm] || '0'; // 이전 값이 없으면 '0'으로 설정
          if (newItem[chnnlNm] === undefined) {
            transformedItem[chnnlNm] = prevValue;
          } else {
            transformedItem[chnnlNm] = newItem[chnnlNm];
          }
          prevValues[chnnlNm] = transformedItem[chnnlNm]; // 현재 값을 이전 값으로 설정
        });

        return transformedItem;
      }).map(item => {
        const reorderedItem = {};
        reorderedItem['YMD'] = item['YMD'];
        transformedList.forEach(({ chnnlNm }) => {
          reorderedItem[chnnlNm] = item[chnnlNm];
        });
        reorderedItem['name'] = item['name'];
        return reorderedItem;
      });

      setDatedData(formattedData);
    }
  }, [chartData, transformedList]);

  // console.log("datedData ==> ", datedData);
  return datedData;
}
  
function SRD_Chart(props) {
  const { searchBar, chartData, transformedList, searchButton } = props;
  const colors = [
    "dimgray", "dodgerblue", "darkgreen", "darkorange", "brown", "blueviolet", "green", "blue", "deeppink", "navy"
  ];
  const [searchPressed, setSearchPressed] = useState(searchButton);
  const [filteredData, setFilteredData] = useState([]);
  const [brushExtent, setBrushExtent] = useState([0, 1000]); // 초기 확대 범위
  const [seriesVisibility, setSeriesVisibility] = useState({});
  let brushDate = '00/00';
  const datedData = useChartData(chartData, transformedList);

  // console.log("transformedList >> ", transformedList);

  if((filteredData.length === 0) && (datedData.length >0)) {    // 초기화
    setFilteredData(datedData);
    // console.log("filteredData ==> ", filteredData);
  }

  useEffect(() => {
    setSeriesVisibility(() => {
      const initialVisibility = {};
      transformedList.forEach((item) => {
        initialVisibility[item.chnnlNm] = false;
      });
      return initialVisibility;
    });
  }, [transformedList]);

  const formatXAxis = (tick) => {   // X축 tick 표시, 'MM/DD HH:mm'
    if (typeof tick == 'string') {
      // setSearchPressed(true);
      return moment(tick).format('HH:mm');
    } else {
      console.warn(`Invalid timestamp in YMD: ${tick}`);
      return tick;
    }
  };



  const formatBrushXAxis = (tick) => {
    if (typeof tick === 'string') {
      const hasName = datedData.some(item => item.name);
      if (!hasName) return '';
      const formattedDate = moment(tick).format('MM/DD');
      if (datedData.length === 0 || typeof datedData[0] !== 'object' || !('name' in datedData[0])) {
        if (formattedDate !== brushDate) {
          brushDate = formattedDate;
          return formattedDate;
          } else {
            return '     ';
          }
      } else {
        const hasName = datedData.some(item => item.name);
        if (!hasName) return '';
  
        const existingNames = datedData.map(item => item.name);
        if (!existingNames.includes(brushDate)) {
          if (formattedDate !== brushDate) {
          brushDate = formattedDate;
          return formattedDate;
          } else {
            return '     ';
          }
        } else {
          return '      ';
        }
      }
    } else {
      console.warn(`Invalid timestamp in YMD: ${tick}`);
    }
  };
    
  const formatTooltipLabel = (tick) => {  // 툴팁 날짜, 'YYYY-MM-DD HH:mm'
    if (typeof tick == 'string') {
      return moment(tick).format('YYYY-MM-DD HH:mm');
    } else {
      console.warn(`Invalid timestamp in YMD: ${tick}`);
      return tick;
    }
  }; 

  const formatTooltip  = (tick) => {
    if(transformedList) {
      const DchnnlNo = transformedList.map(item => item.chnnlNo);
      for (let i = 0; i < DchnnlNo.length; i++) {
        const channelName = transformedList[i]?.chnnlNm ?? '';
        if (channelName) {
          return tick;
        }
      }
      return '';
  };
  };
  
  const formatLegend = (tick) => { 
    // console.log("formatLegend>>transformedList >> ", transformedList);
    if (!transformedList || transformedList.length === 0) {
      return '';
    }
      const DchnnlNo = transformedList.map(item => item.chnnlNo);
      for (let i = 0; i < DchnnlNo.length; i++) {
        const channelName = transformedList[i]?.chnnlNm ?? '';
        if (channelName) {
          return tick;
        }
      }
      return '';
  };
  
  const onBrushChange = (brushState) => {
    // console.log("onBrushChange>>transformedList >> ", transformedList);
    const { startIndex, endIndex } = brushState;

    setBrushExtent([startIndex, endIndex]);
    setSearchPressed(true);

    const newData = datedData.filter((_, index) => index >= startIndex && index <= endIndex);
    setFilteredData(newData);
    // console.log("filteredData >> ", filteredData);
  };

  // useEffect(() => {
  //   console.log("filteredData가 변경되었습니다. 브러쉬를 다시 렌더링합니다.");
  
  //   // filteredData 상태가 변경될 때마다 브러쉬의 시작 및 끝 인덱스를 업데이트합니다.
  //   const startIndex = brushExtent[0];
  //   const endIndex = brushExtent[1];
  
  //   const newData = datedData.filter((_, index) => index >= startIndex && index <= endIndex);
  //   setFilteredData(newData);
  //   console.log("filteredData >> ", filteredData);
  // }, [filteredData]); // filteredData 상태가 변경될 때마다 실행  

  /*
  const handleWheel = (event) => {
    if (searchPressed && datedData && transformedList && transformedList.length > 0) {
      const [ startIndex, endIndex ] = brushExtent;
      const centerIndex = Math.floor((startIndex + endIndex) / 2);
      const zoomFactor = event.deltaY > 0 ? 1.1 : 0.9;
      const zoomIndex = Math.floor(centerIndex - (centerIndex * zoomFactor));

      const newStartIndex = Math.max(1, Math.floor(startIndex + zoomIndex));
      const newEndIndex = Math.min(datedData.length-1, Math.floor(endIndex - zoomIndex));

      if ((newEndIndex - newStartIndex) > 0 && (newEndIndex < datedData.length)) {  
        setBrushExtent([newStartIndex, newEndIndex]);
      }
      // console.log("handleWheel>>brushExtent >> ", brushExtent);
    }
    return;
  };
  */

  const toggleSeriesVisibility = (seriesName) => {
    setSeriesVisibility(prevState => ({
      ...prevState,
      [seriesName.dataKey]: !prevState[seriesName.dataKey]
    }));
  };


  return (
    <div style={{ width: "99%", height: "85%" }} >
    {/* <div style={{ width: "99%", height: "85%" }} onWheel={handleWheel}> */}
      {searchBar}
      <ResponsiveContainer width="100%" height="100%">
        {searchPressed && (transformedList.length === 0 || typeof datedData === 'undefined' || datedData.length) === 0 ? (<div></div>) : <div></div>}
        {/* {searchPressed && (transformedList.length === 0 || datedData.length) === 0 ? (<div>항목 선택이 잘 못 되었으니 확인바랍니다...</div>) : <div></div>} */}
        {Array.isArray(datedData) && typeof datedData !== 'undefined' && datedData && datedData.length > 0 ? (
          <LineChart
            width={1600}
            height={800}
            data={datedData}
            margin={{ top: 10, right: 10, bottom: 0, left: 0 }}
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis
              dataKey="YMD"
              domain={
                datedData.length > 0
                  ? [datedData[0].YMD, datedData[datedData.length - 1].YMD]
                  : ["dataMin", "dataMax"]
              }
              tickFormatter={formatXAxis}
            />
            <YAxis type="number" domain={[-20, 110]} ticks={[-20, -10, 0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]} />
            <Tooltip
              labelFormatter={formatTooltipLabel}
              formatter={formatTooltip}
              backgroundColor="yellow"
            />
            {transformedList.length > 0 && datedData.length > 0 && (
              <Legend
                verticalAlign="top"
                align="left"
                iconType="square" 
                tickFormatter={formatLegend}
                onClick={toggleSeriesVisibility}
              />
            )}
            {/* {Array.isArray(datedData) && datedData.length > 0 && transformedList.length > 0 && ( */}
            {Array.isArray(datedData) && datedData.length > 0 && filteredData.length > 0 && transformedList.length > 0 && (
              <Brush
                dataKey="YMD"   // brush start/end date time
                // startIndex={brushExtent[0]}
                // endIndex={brushExtent[1]}
                onChange={onBrushChange}
                stroke="green"
                fill="#d1d1fa"
                fillOpacity={0.3}
                travellerWidth={10}
                height={100}
                margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
                unit="minute"
              >
                <LineChart
                  width={brushExtent[1] - brushExtent[0]}
                  height={70}
                  data={filteredData}
                >
                  <XAxis dataKey="YMD" tickFormatter={formatBrushXAxis} />
                  <YAxis hide />
                  {transformedList.map((item, index) => (
                    <Line
                      key={item.chnnlNm}
                      dataKey={item.chnnlNm}
                      type="linear"
                      strokeWidth={1}
                      dot={false}
                    />
                  ))}
                </LineChart>
              </Brush>
            )}
            {transformedList.map((item, index) => (
              <Line
                key={`${item.chnnlNm}-${seriesVisibility[item.chnnlNm]}`}
                dataKey={item.chnnlNm}
                type="linear"
                connectNulls
                stroke={colors[index % colors.length]}
                strokeWidth={2}
                activeDot={{ r: 7, fill: 'red' }}
                dot={false}
                hide={seriesVisibility[item.chnnlNm]}
              />
            ))}
          </LineChart>
        ) : (
          <div>...</div>
        )}
      </ResponsiveContainer>
    </div>
  );
}

export default SRD_Chart;